var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgOrangeLock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_162_1",
    "data-name": "Component 162 \\u2013 1",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1661",
    "data-name": "Rectangle 1661",
    width: 25,
    height: 25,
    rx: 12,
    transform: "translate(25) rotate(90)",
    fill: "#ffb300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_lock_outline_24px",
    d: "M9.806,12.611A1.451,1.451,0,1,0,8.354,11.16,1.456,1.456,0,0,0,9.806,12.611ZM14.16,6.08h-.726V4.629a3.629,3.629,0,0,0-7.257,0V6.08H5.451A1.456,1.456,0,0,0,4,7.531v7.257A1.456,1.456,0,0,0,5.451,16.24H14.16a1.456,1.456,0,0,0,1.451-1.451V7.531A1.456,1.456,0,0,0,14.16,6.08Zm-6.6-1.451a2.25,2.25,0,0,1,4.5,0V6.08h-4.5Zm6.6,10.16H5.451V7.531H14.16Z",
    transform: "translate(2.66 3.38)",
    fill: "#373737"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOrangeLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Orange_Lock.e2520030.svg";
export { ForwardRef as ReactComponent };